export const effects = {
  glass: {
    light: 'backdrop-blur-md bg-white/80 border border-white/20',
    dark: 'backdrop-blur-md bg-black/5 border border-black/5'
  },
  shadows: {
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl'
  },
  rounded: {
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    xl: 'rounded-xl',
    full: 'rounded-full'
  },
  transitions: {
    default: 'transition-all duration-200 ease-in-out',
    slow: 'transition-all duration-300 ease-in-out',
    fast: 'transition-all duration-150 ease-in-out'
  }
} 